//@ts-check

import { formatNumber } from "../utilities/numbers";


document.addEventListener( 'DOMContentLoaded', function() {
    const poundButton = /** @type {HTMLButtonElement} */ ( document.getElementById( 'toggle-pound' ) );
    const euroButton = /** @type {HTMLButtonElement} */ ( document.getElementById( 'toggle-euro' ) );

    if ( !poundButton || !euroButton ) return;

    const currentCurrency = getCurrency();
    if ( currentCurrency === 'EUR' ) {
        euroButton.classList.add( 'active' );
        poundButton.classList.remove( 'active' );
        setCurrency( 'EUR' );
    } else {
        poundButton.classList.add( 'active' );
        euroButton.classList.remove( 'active' );
        setCurrency( 'GBP' );
    }

    poundButton.addEventListener( 'click', function() {
        if ( poundButton.classList.contains( 'active' ) ) return;

        poundButton.classList.add( 'active' );
        euroButton.classList.remove( 'active' );

        setCurrency( 'GBP' );
    } );

    euroButton.addEventListener( 'click', function() {
        if ( euroButton.classList.contains( 'active' ) ) return;

        poundButton.classList.remove( 'active' );
        euroButton.classList.add( 'active' );

        setCurrency( 'EUR' );
    } );
} );


/**
 * @typedef {'EUR'|'GBP'} Currency
 * @typedef {'€'|'£'} CurrencySymbol
 *
 * @returns {Currency}
 */
export function getCurrency() {
    return sessionStorage.getItem( 'currency' ) ?? 'GBP';
}
/**
 *
 * @param {Currency} currency
 */
export function setCurrency( currency ) {
    sessionStorage.setItem( 'currency', currency );

    if ( currency === 'EUR' ) {
        document.body.classList.remove( 'currency-is-gbp' );
        document.body.classList.add( 'currency-is-eur' );
    } else {
        document.body.classList.add( 'currency-is-gbp' );
        document.body.classList.remove( 'currency-is-eur' );
    }

    document.dispatchEvent( new CustomEvent( 'currency_change', { detail: { currency } } ) );
}

/**
 * @return {CurrencySymbol}
 */
export function getCurrencySymbol() {
    const currency = getCurrency();

    if ( currency === 'GBP' ) {
        return '£';
    } else if ( currency === 'EUR' ) {
        return '€';
    } else {
        return '£';
    }
}

export function is_gbp() {
    return getCurrency() === 'GBP';
}


/**
 * @param {string|number|null} price
 * @param {boolean} brackets
 *
 * @returns {string} HTML for the price, including the currency symbol and + VAT suffix
 */
export function formatPrice( price, brackets = false, asHTML = true ) {
    if ( !price || price === '' || price == 0 ) return '';
    const currency = getCurrency();
    const symbol = getCurrencySymbol();

    if ( !asHTML ) {
        return `${symbol}${formatNumber( price )} + VAT`;
    }

    let formatted = `<span class="price__price">${formatNumber( price )}</span>`;
    formatted = `<span class="price__symbol">${symbol}</span>${formatted}`;
    formatted = `${formatted}<small class="price__suffix"> + VAT</small>`;

    if ( brackets ) {
        formatted = `(${formatted})`;
    }

    return `<span class="price ${symbol}">${formatted}</span>`;
}
